export const translations = {
  uk: {
    transactions: "Транзакції",
    dashboard_title: "Панель результативності арбітражу",
    data_table: "Таблиця даних",
    analytics: "Аналітика",
    select_all: "Обрати усіх",

    // Table Headers
    date: "ДАТА",
    keitaro: "KEITARO",
    fluxar: "FLUXAR",
    spent_all: "ВИТРАТИ",
    net_profit: "ЧИСТИЙ",
    operator_share: "ЧАСТКА (U)",
    profit: "ПРИБУТОК",
    roi: "ROI %",
    io: "IO",
    io_detailed: "IO 1,5%+0,10$",
    other_spent: "ІН. ВИТРАТИ",
    pending: "PENDING",
    comment: "КОМЕНТАР",
    total: "РАЗОМ",

    // Tooltips
    keitaro_tooltip: "Автоматизований підтверджений дохід (sale_revenue)",
    net_profit_tooltip: "Розрахунок: (Прибуток + Keitaro + Fluxar) - Витрати",
    profit_tooltip: "Ручне введення прибутку",
    pending_tooltip:
      "Карткові витрати Karta, що ще висять (AUTHORIZED/PENDING): spend + fees. Рахуються окремо і не входять у витрати/чистий.",
    pending_net: "ЧИСТИЙ (ПРОГНОЗ)",
    pending_net_tooltip:
      "Якою стане Частка (U), якщо pending засетлиться: NET(U) − Pending spend × % − Fees. Fees б'ють у повному обсязі. Завжди ≤ NET(U).",

    // Columns settings
    columns_settings: "Колонки",

    // Pending summary
    pending_total: "У PENDING",
    pending_hint: "Karta-транзакції, що ще висять (spend + fees)",

    // Summary Card
    operator_share_label: "Частка оператора",
    profit_split: "Відсоток прибутку",
    saved: "Збережено",
    percentage_updated: "Відсоток оновлено",
    showcase_profit: "Showcase (Міс.)",
    showcase_updated: "Showcase прибуток оновлено",
    final_user_share: "Чиста частка",
    my_share: "Моя частка",
    calculation_formula: "Чистий × {val}% − IO 1.5%",
    plus_showcase: "+ Showcase",

    // Toolbar
    select_operator: "Оберіть оператора",
    month: "Місяць",
    reload: "Оновити",
    sync_keitaro: "Синхронізація доходу Keitaro (Поточний місяць)",
    mapping: "Налаштування інтеграцій",
    backup: "Надіслати бекап у Telegram",
    sending: "Надсилаю...",
    preparing_backup: "Підготовка бекапу",
    sent_success: "✅ Надіслано!",
    sent_msg: "Бекап доставлено в Telegram",
    error: "Помилка",
    error_backup: "Не вдалося надіслати бекап",
    error_load: "Помилка завантаження",

    // Mapping Modal
    mapping_title: "Мапінг сервісів",
    mapping_desc:
      "Призначте групи кампаній Keitaro / Fluxar та ID користувачів Karta для автоматичної синхронізації.",
    user: "Користувач",
    keitaro_group: "Група Keitaro",
    fluxar_group: "Група Fluxar",
    sync_fluxar: "Синхронізація доходу Fluxar (Поточний місяць)",
    fluxar_synced: "Дохід Fluxar синхронізовано",
    fluxar_tooltip: "Автоматизований підтверджений дохід Fluxar",
    karta_id: "Karta ID користувача",
    none: "Відсутня",
    mapping_saved: "Мапінг для {val} збережено",
    karta_saved: "Karta ID для {val} збережено",

    // Insights
    revenue: "ДОХІД",
    expenses: "ВИТРАТИ",
    no_data: "немає даних",
    vs_prev_day: "порв. з попереднім днем",

    analytics_intro: "Поточний результат і прогноз після переходу pending у settled.",
    analytics_revenue_hint: "Keitaro + Fluxar + ручний дохід",
    analytics_settled: "Без pending",
    analytics_with_pending: "З pending",
    analytics_compare: "Порівняння",
    analytics_business_net: "Прибуток до розподілу",
    analytics_stale: "Фільтри змінено. Сформуйте тренди знову. Нижче — попередня вибірка.",
    analytics_cost_mode: "Врахування витрат",
    analytics_roi_hint: "Прибуток / витрати × 100%",
    analytics_pending: "Pending-спенд",
    analytics_pending_hint: "У прогнозі весь pending-спенд враховано як витрати. Дохід залишається поточним.",
    analytics_pending_fees: "Pending-комісія (окремо, для NET U)",
    analytics_daily: "Динаміка за днями",
    analytics_chart_hint: "Суми за день. Пунктир — прогноз після settled. Комісії NET U не включені.",
    analytics_metric: "Показник графіка",
    analytics_users: "Результати користувачів",
    analytics_users_hint: "Прибуток до розподілу, як NET PROFIT у таблиці. Сортування за прибутком обраного режиму.",
    analytics_projected_net: "Прибуток з pending",
    analytics_empty: "За обраними фільтрами транзакцій немає.",
    // Dynamics
    filters_required: "Необхідні фільтри",
    filters_msg: "Будь ласка, оберіть хоча б одного користувача та один місяць",
    error_analytics: "Помилка завантаження аналітичних даних",
    select_users: "Оберіть користувачів",
    pick_users: "Оберіть користувачів для відстеження",
    select_months: "Оберіть місяці",
    pick_months: "Оберіть місяці",
    generate_trends: "Сформувати тренди",
    performance_overview: "Загальний огляд результативності",
    combined_metrics: "Комбіновані метрики за всіма обраними фільтрами",
    total_net: "ЗАГАЛЬНИЙ ЧИСТИЙ",
    avg_roi: "СЕРЕДНІЙ ROI",
    combined_net_name: "Сумарний чистий прибуток",
    individual_trends: "Тренди окремих користувачів",
    days: "Днів",
    total_spent: "Загальні витрати",
    analytics_placeholder:
      'Оберіть користувачів та місяці вище та натисніть "Сформувати тренди", щоб побачити аналітику.',
  },
  en: {
    transactions: "Transactions",
    dashboard_title: "Arbitrage Performance Dashboard",
    data_table: "Data Table",
    analytics: "Analytics",
    select_all: "Select All",

    // Table Headers
    date: "DATE",
    keitaro: "KEITARO",
    fluxar: "FLUXAR",
    spent_all: "SPENT ALL",
    net_profit: "NET PROFIT",
    operator_share: "NET (U)",
    profit: "PROFIT",
    roi: "ROI %",
    io: "IO",
    io_detailed: "IO 1,5%+0,10$",
    other_spent: "OTHER SPENT",
    pending: "PENDING",
    comment: "COMMENT",
    total: "TOTAL",

    // Tooltips
    keitaro_tooltip: "Automated confirmed revenue (sale_revenue)",
    net_profit_tooltip: "Calculation: (Manual + Keitaro + Fluxar) - Spent",
    profit_tooltip: "Manual profit entry",
    pending_tooltip:
      "Karta card spend still hanging (AUTHORIZED/PENDING): spend + fees. Counted separately, excluded from spent/net.",
    pending_net: "NET (PROJ.)",
    pending_net_tooltip:
      "What NET(U) becomes if pending settles: NET(U) − Pending spend × % − Fees. Fees hit in full. Always ≤ NET(U).",

    // Columns settings
    columns_settings: "Columns",

    // Pending summary
    pending_total: "IN PENDING",
    pending_hint: "Karta transactions still hanging (spend + fees)",

    // Summary Card
    operator_share_label: "Operator Share",
    profit_split: "Profit split %",
    saved: "Saved",
    percentage_updated: "Percentage updated",
    showcase_profit: "Showcase Profit (Monthly)",
    showcase_updated: "Showcase profit updated",
    final_user_share: "Final User Share",
    my_share: "My Share",
    calculation_formula: "Net × {val}% − IO 1.5%",
    plus_showcase: "+ Showcase",

    // Toolbar
    select_operator: "Select operator",
    month: "Month",
    reload: "Reload",
    sync_keitaro: "Sync Keitaro Profit (Current Month)",
    mapping: "Integration Mapping",
    backup: "Send CSV backup to Telegram",
    sending: "Sending...",
    preparing_backup: "Preparing backup",
    sent_success: "✅ Sent!",
    sent_msg: "Backup delivered to Telegram",
    error: "Error",
    error_backup: "Failed to send backup",
    error_load: "Failed to load",

    // Mapping Modal
    mapping_title: "Service Mapping",
    mapping_desc:
      "Assign Keitaro / Fluxar Campaign Groups and Karta User IDs to enable automated sync.",
    user: "User",
    keitaro_group: "Keitaro Group",
    fluxar_group: "Fluxar Group",
    sync_fluxar: "Sync Fluxar Revenue (Current Month)",
    fluxar_synced: "Fluxar revenue synced",
    fluxar_tooltip: "Automated confirmed Fluxar revenue",
    karta_id: "Karta User ID",
    none: "None",
    mapping_saved: "Mapping for {val} saved",
    karta_saved: "Karta ID for {val} saved",

    // Insights
    revenue: "REVENUE",
    expenses: "EXPENSES",
    no_data: "no data",
    vs_prev_day: "vs previous day",

    // Dynamics
    filters_required: "Filters required",
    filters_msg: "Please select at least one user and one month",
    error_analytics: "Failed to fetch analytics data",
    select_users: "Select Users",
    pick_users: "Pick users to track",
    select_months: "Select Months",
    pick_months: "Pick months",
    generate_trends: "Generate Trends",
    analytics_intro: "Current performance and the forecast after pending transactions settle.",
    analytics_revenue_hint: "Keitaro + Fluxar + manual revenue",
    analytics_settled: "Without pending",
    analytics_with_pending: "With pending",
    analytics_compare: "Compare",
    analytics_business_net: "Profit before distribution",
    analytics_stale: "Filters changed. Generate trends again. Results below show the previous selection.",
    analytics_cost_mode: "Expense basis",
    analytics_roi_hint: "Profit / expenses × 100%",
    analytics_pending: "Pending spend",
    analytics_pending_hint: "The forecast treats all pending spend as expenses. Revenue stays unchanged.",
    analytics_pending_fees: "Pending fees (separate, for NET U)",
    analytics_daily: "Daily performance",
    analytics_chart_hint: "Daily totals. Dashed line: forecast after settlement. NET U fees are excluded.",
    analytics_metric: "Chart metric",
    analytics_users: "User performance",
    analytics_users_hint: "Profit before distribution, matching NET PROFIT in the table. Sorted by profit in the selected mode.",
    analytics_projected_net: "Profit with pending",
    analytics_empty: "No transactions match the selected filters.",
    performance_overview: "Total Performance Overview",
    combined_metrics: "Combined metrics for all selected filters",
    total_net: "TOTAL NET",
    avg_roi: "AVG ROI",
    combined_net_name: "Combined Net Profit",
    individual_trends: "Individual User Trends",
    days: "Days",
    total_spent: "Total Spent",
    analytics_placeholder:
      'Select users and months above and click "Generate Trends" to see analytics.',
  },
};
